export async function loadAdyenKyc() {
  await import('@adyen/kyc-components/styles.css');
  const module = await import('@adyen/kyc-components');
  return module.default;
}
